import { DatePicker } from "antd";
import moment from "moment-timezone";
import React from "react";

const DateFilter = ({
  onClose,
  setStartDate,
  setEndDate,
  handleDateSubmit,
  startDate,
  endDate,
}) => {
  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  return (
    <section className="fixed z-50 inset-0 overflow-y-auto duration-300 ease-in-out font-sans">
      <div className="flex items-center justify-center min-h-screen p-4 text-center sm:p-6">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div
            className="absolute inset-0 bg-foreground/60"
            onClick={onClose}
          ></div>
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block w-full bg-card rounded-xl border border-border space-y-4 text-left overflow-hidden shadow-theme transform transition-all sm:align-middle max-w-lg md:max-w-2xl">
          <div className="relative w-full flex flex-col items-center rounded-xl py-2 overflow-hidden text-foreground bg-card bg-clip-border">
            <div className="h-1.5 card-gradient-strip w-full" />
            <span className="font-heading text-foreground font-bold capitalize text-base sm:text-xl py-4 px-4 text-center">
              Select Date Range
            </span>
            <div className="flex items-stretch md:items-center justify-center md:flex-row flex-col gap-4 border-t border-border w-full py-4 px-4 sm:px-6">
              <div className="flex flex-col w-full sm:w-[16rem] sm:mx-auto md:mx-0 items-stretch">
                <label className="bef-label text-center sm:text-left">Start Date</label>
                  <DatePicker
              id="startDate"
              value={startDate ? moment(startDate) : null} 
              onChange={(date, dateString) => handleStartDateChange(date, dateString)}
              format="DD/MM/YYYY"
              placeholder="Select a Start Date"
              className="w-full bef-input"
              disabledDate={(current) => current && current > moment().endOf("day")}
            />
              </div>
              <div className="flex flex-col w-full sm:w-[16rem] sm:mx-auto md:mx-0 items-stretch">
                <label className="bef-label text-center sm:text-left">End Date</label>
                <DatePicker
              id="endDate"
              value={endDate ? moment(endDate) : null}
              onChange={(date, dateString) => handleEndDateChange(date, dateString)}
              format="DD/MM/YYYY"
              placeholder="Select an End Date"
              className="w-full bef-input"
              disabledDate={(current) =>
                current && (current > moment().endOf("day") || current < moment(startDate).startOf("day"))
              } 
            />
              </div>
            </div>
            <div className="flex items-stretch justify-center md:flex-row flex-col gap-3 sm:gap-4 w-full py-4 px-4 sm:px-6">
              <button
                onClick={onClose}
                type="button"
                className="bef-btn-secondary w-full md:max-w-[200px]"
              >
                Cancel
              </button>
              <button
                onClick={handleDateSubmit}
                type="button"
                className="bef-btn-primary w-full md:max-w-[200px]"
              >
                Save
              </button>
            </div>
          </div>
          </div>
      </div>
    </section>
  );
};

export default DateFilter;
